window.okeReviewsWidgetOnInit = function () {
    setupWidgetHeader();
    let observer = new MutationObserver(setupWidget);
    let reviewMainElement = document.querySelector('.js-okeReviews-reviews-main');

    observer.observe(reviewMainElement, {
        childList: true
    });
    setupWidget();
};

function setupWidgetHeader() {
    let writeAReviewButton = document.querySelector('.js-okeReviews-writeReview');
    let reviewsControl = document.querySelector('.okeReviews-reviews-controls');

    // Move WaR button
    if (writeAReviewButton && reviewsControl) {
        let reviewsControlSelect = reviewsControl.querySelector('.okeReviews-reviews-controls-select');
        reviewsControlSelect.insertAdjacentElement('afterbegin', writeAReviewButton);
    }
}

function setupWidget() {
    // Move recommendation
    let reviewRecommendations = document.querySelectorAll('.okeReviews-reviews-review .okeReviews-review-recommendation');
    let reviewerInfoBlocks = document.querySelectorAll('.okeReviews-reviews-review .okeReviews-review-reviewer-profile-details');

    if (reviewRecommendations.length > 0 && reviewerInfoBlocks.length > 0)
    for (let i = 0; i < reviewRecommendations.length; i++) {
        reviewerInfoBlocks[i].insertAdjacentElement('beforeend' ,reviewRecommendations[i])
    }
}
